/**
 * 협력업체 부팅관리
 */
export default {
    initialize: function () {
        // 상단바 [정보변경] · 정보변경 모달의 취소/변경하기 — data-p-info="open|close|save"
        $(document).on('click', '[data-p-info]', function () {
            const fn = $j.F.Partner.InfoModal[this.dataset.pInfo];
            if (typeof fn === 'function') fn.call($j.F.Partner.InfoModal);
        });
    }
};
